const propToAttribute = {
    'className': 'class',
};

export function render(element, context = {}, text = true) {
    if (element === null) {
        return '';
    }

    if (typeof element != 'object') {
        throw new Error('element is not an object');
    }

    let domElement;

    switch (typeof element.type) {
        case 'string':
            domElement = document.createElement(element.type);
            let {children, ...rest} = element.props;

            for (let prop in rest) {
                let attribute = prop;
                if (propToAttribute[prop]) {
                    attribute = propToAttribute[prop];
                }

                domElement.setAttribute(attribute, rest[prop]);
            }

            if (typeof children == 'string') {
                children = [children];
            }

            for (let index in children) {
                let child = children[index];
                switch (typeof child) {
                    case 'string':
                        domElement.appendChild(document.createTextNode(child));
                        break;
                    case 'object':
                        if (child.type && child.props) {
                            let childDomElement = render(child, context, false);
                            domElement.appendChild(childDomElement);
                        }
                        break;
                }
            }
            break;
        case 'function':
            let returnedElement, overridenContext;
            if (typeof element.type.prototype.render == 'function') {
                if (typeof element.type.prototype.getChildContext == 'function') {
                    overridenContext = element.type.prototype.getChildContext.call(element);
                }
                returnedElement = element.type.prototype.render.call({...element, context});
            } else {
                returnedElement = element.type.apply(undefined, [element.props, context]);
            }

            if (returnedElement === undefined) {
                console.log(element.type.name, 'returned undefined with props', element.props);
            }

            return render(returnedElement, overridenContext || context, text);

    }

    if (!domElement) {
        return null;
    }

    return text ? domElement.outerHTML : domElement;
}



// WEBPACK FOOTER //
// ./local_modules/react-renderer/index.js